/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationFiltersRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationFiltersRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationFiltersRequest>): ScheduleRecommendationFiltersRequest {
        let obj = Object.assign(new ScheduleRecommendationFiltersRequest(), model);
        ScheduleRecommendationFiltersRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationFiltersRequest>): ScheduleRecommendationFiltersRequest {
        if (!model) return null;
        return ScheduleRecommendationFiltersRequest.newInstance(<ScheduleRecommendationFiltersRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationFiltersRequest) {
        if (!obj) return;

        models.ScheduleRecommendationFiltersRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationFiltersRequest): boolean {
        Object.setPrototypeOf(obj, ScheduleRecommendationFiltersRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant Ids
     */
    tenant_ids: Array<string>;

    /**
     * Service Account Ids
     */
    service_account_ids: Array<string>;

    /**
     * Service Names
     */
    service_names: Array<models.CloudServiceName>;

}
